module.exports = __webpack_public_path__ + "static/img/function2.941d7d55.png";